import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "./Services.css";

import { FaFileMedical, FaClipboardList, FaHandsHelping, FaBrain, FaFlask } from "react-icons/fa";

import LekarskiUverenija from "./LekarskiUverenija";
import PrvaPomosh from "./PrvaPomos";
import PsihosocijalniRizici from "./PsihosocijalniRizici";
import SistematskiPregledi from "./SistematskiPregledi";
import Laboratorija from "./Laboratorija";

function Services() {
  const [activeService, setActiveService] = useState(null);

  // 👉 LISTENER од Navbar
  useEffect(() => {
    const handler = (e) => {
      setActiveService(e.detail);
    };

    window.addEventListener("openService", handler);

    return () => window.removeEventListener("openService", handler);
  }, []);
  useEffect(() => {
    const openHandler = (e) => {
      setActiveService(e.detail);
    };

    const closeHandler = () => {
      setActiveService(null);
    };

    window.addEventListener("openService", openHandler);
    window.addEventListener("closeServiceModal", closeHandler);

    return () => {
      window.removeEventListener("openService", openHandler);
      window.removeEventListener("closeServiceModal", closeHandler);
    };
  }, []);

  useEffect(() => {
  const path = window.location.pathname;

  if (path === "/lekarski-uverenija") {
    setActiveService("lekarski");
  }

  if (path === "/sistemski-pregledi") {
    setActiveService("sistemski");
  }

  if (path === "/prva-pomos") {
    setActiveService("prva");
  }

  if (path === "/psihosocijalni-rizici") {
    setActiveService("psihosocijalni");
  }

  if (path === "/laboratorija") {
    setActiveService("lab");
  }
}, []);

const closeModal = () => {
  setActiveService(null);
  window.history.pushState({}, "", "/");
};

  return (
    <section id="services" className="services">
      <div className="container">

        <div className="services-header">
          <h2>Услуги</h2>
          <div className="line"></div>
          <p>Изберете услуга и дознајте повеќе</p>
        </div>

        <div className="services-grid">

          <div className="service-preview" onClick={() => setActiveService("lekarski")}>
            <div className="preview-icon"><FaFileMedical /></div>
            <h4>Лекарски уверенија</h4>
            <p>Документи за работа и администрација</p>
          </div>

          <div className="service-preview" onClick={() => setActiveService("sistemski")}>
            <div className="preview-icon"><FaClipboardList /></div>
            <h4>Систематски прегледи</h4>
            <p>Комплетни здравствени проверки</p>
          </div>

          <div className="service-preview" onClick={() => setActiveService("prva")}>
            <div className="preview-icon"><FaHandsHelping /></div>
            <h4>Прва помош</h4>
            <p>Обука за итни ситуации</p>
          </div>

          <div className="service-preview" onClick={() => setActiveService("psihosocijalni")}>
            <div className="preview-icon"><FaBrain /></div>
            <h4>Психосоцијални ризици</h4>
            <p>Burnout и стрес менаџмент</p>
          </div>

          <div className="service-preview" onClick={() => setActiveService("lab")}>
            <div className="preview-icon"><FaFlask /></div>
            <h4>Лабораторија</h4>
            <p>Брзи и прецизни анализи</p>
          </div>

        </div>

        {/* MODAL */}
        {activeService && createPortal(
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closeModal}>✕</button>

              {activeService === "lekarski" && <LekarskiUverenija />}
              {activeService === "sistemski" && <SistematskiPregledi />}
              {activeService === "prva" && <PrvaPomosh />}
              {activeService === "psihosocijalni" && <PsihosocijalniRizici />}
              {activeService === "lab" && <Laboratorija />}

            </div>
          </div>,
          document.body
        )}

      </div>
    </section>
  );
}

export default Services;